import React, { useState } from "react";
import { Modal } from 'react-bootstrap';
import ModalTransactionSuccessfully from "./ModalTransactionSuccessfully";
import ModalTransactionCancel from "./ModalTransactionCancel";
import ModalTransactionInProgress from "./ModalTransactionInProgress";
import { useEffect } from "react";

const PaymentStatus = (props) => {
    const [isModelEnable, setIsModelEnable] = useState(false);

    useEffect(() => {
        setIsModelEnable(true);
    }, [props.status]);

    const handleClose = () => {
        setIsModelEnable(false);
        props.handleClose();
    }
    return (
        <>
            <Modal show={isModelEnable} onHide={handleClose} className='modal-subscription modal-transaction' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    {props?.status === "success" && <ModalTransactionSuccessfully />}
                    {props?.status === "failed" && <ModalTransactionCancel />}
                    {props?.status === "pending" && <ModalTransactionInProgress />}
                </Modal.Body>
            </Modal>
        </>
    );
};

export default PaymentStatus;